import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";

@Injectable({ providedIn: "root" })
export class NavigationService {
  private history: string[] = [];

  constructor(private router: Router, private location: Location) {
    this.router.events.subscribe((event:any) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
        // console.log(this.history)
      }
      // console.log(this.history.length)
    });
  }

  back(): void {
    this.history.pop();
    if (this.history.length > 0) {
      // this.router.navigateByUrl("../");
      this.location.back();
    } else {
      this.router.navigateByUrl("/home");
    }
  }
}
